import BaseRepository from "@/baseRepository/BaseRepository";
const resource = `/api/v1/measurementquantities`;

export default {
  getActiveMeasurementQuantities(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}`, {
      baseURL,
      headers,
      params
    });
  },
  getMeasurementQuantityActiveUnits(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}/units`, {
      baseURL,
      headers,
      params
    });
  },
  getMeasurementQuantityConvert(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}/convert`, {
      baseURL,
      headers,
      params
    });
  },
  getMeasurementQuantityConvertByName(id, baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/${id}/convert-by-name`, {
      baseURL,
      headers,
      params
    });
  },
  getConvertValueMeasurementQuantities(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/convert`, {
      baseURL,
      headers,
      params
    });
  },
  getConvertValueMeasurementQuantitiesByName(baseURL = {}, headers = {}, params = {}) {
    return BaseRepository.get(`${resource}/convert-by-name`, {
      baseURL,
      headers,
      params
    });
  },
};
